import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=189f6512"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189f6512')) {
      api.createRecord('189f6512', component.options)
    } else {
      api.reload('189f6512', component.options)
    }
    module.hot.accept("./DashboardLayout.vue?vue&type=template&id=189f6512", function () {
      api.rerender('189f6512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/dashboard/DashboardLayout.vue"
export default component.exports